import { render, staticRenderFns } from "./sections.vue?vue&type=template&id=129e2050&scoped=true&"
import script from "./sections.vue?vue&type=script&lang=js&"
export * from "./sections.vue?vue&type=script&lang=js&"
import style0 from "./sections.vue?vue&type=style&index=0&id=129e2050&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129e2050",
  null
  
)

export default component.exports